export const INTENT = "11%";
export const URL_HOST = window.location.origin;
export const URL_FILE = `${URL_HOST}/storage/`;

export const TEST_URL = "https://dv.noapplesin.space/storage/";
